

import React from 'react'
import { PhotoProvider, PhotoView ,PhotoSlider} from 'react-photo-view'
import 'react-photo-view/dist/react-photo-view.css'

const ZoomableImage = ({ src, open,onClose }) => {
  return (
    <>

      <PhotoSlider
        images={[{ src }]}
        visible={open}
        onClose={onClose}
      />
    </>

  )
}

export default ZoomableImage
